<template>
  <!-- 地址中间页弹窗 -->
  <div class="address-popup">
    <mt-popup v-model="show"
              position="bottom"  class="address-popup-box"  :closeOnClickModal="false" >
      <div class="address__info">
        <div class="address-title">
            <span>{{typeTitle}}</span>
            <i class="iconfont icon-close" :class="PostUiIcon.close"
              @click.stop="closePopup()"></i>
        </div>
        <div class="address__container">
          <div class="address__item">
            <div class="address__cell address__container--bounded " @click="checkAddress">
              <p class="address__label">所在地区</p>
              <p class="address__text" v-if="detailInfo.value || addrVal">{{ detailInfo.value || addrVal }}</p>
              <p class="address__placeholder" v-else>请选择所在地区</p>
              <i class="iconfont icon-arrow-right" :class="PostUiIcon.arrowRight" :style="{
                color: detailInfo.value || addrVal ? '#000000' : '#999'
              }"/>
            </div>
            <!-- 内地的 -->
            <div v-if="isLandAddr" class="address__cell address__container--bounded" @click="searchHandle">
              <p class="address__label">详细地址</p>
              <p class="address__text text_detail" v-if="addressDetail">{{addressDetail}}</p>
              <p class="address__placeholder" v-else>请选择详细地址</p>
              <i class="iconfont icon-arrow-right" :class="PostUiIcon.arrowRight" :style="{
                color: addressDetail ? '#000000' : '#999'
              }"/>
            </div>
            <!-- 国际收件人显示 州/市 -->
            <div v-if="tabActiveStore === 'int' && addressType === 'receive' && intProvList.length"
              class="address__cell address__container--bounded"
              @click="intProvVisible = true">
              <p class="address__label">州/市</p>
              <p class="address__text text_detail" v-if="detailInfo.userProvince">{{detailInfo.userProvince}} {{detailInfo.userCity}}</p>
              <p class="address__placeholder" v-else>请选择州/市</p>
              <i class="iconfont icon-arrow-right" />
            </div>
            <!-- 非内地收件人 填写详细地址 -->
            <div v-if="!isLandAddr" class="address__cell address__container--bounded">
              <p class="address__label">详细地址</p>
              <textarea v-model="addressDetail"
                type="text"
                placeholder="请输入详细地址"
                rows="1"
                v-autoHeight="20"
                maxlength="100"
              ></textarea>
            </div>
            <div class="address__cell" @click="openPostCode">
              <p class="address__label">邮政编码</p>
              <input
                v-if="!postCodeList.length"
                v-model="detailInfo.postCode"
                placeholder="请输入邮政编码"
                maxlength="20"
                class="address__text text_detail"
                type="text">
              <template v-else-if="postCodeList.length">
                <p class="address__text" v-if="detailInfo.postCode">{{ detailInfo.postCode }}</p>
                <p class="address__placeholder" v-else>请选择邮政编码</p>
                <i  class="iconfont icon-arrow-right" />
              </template>
            </div>
          </div>
        </div>
        <div class="tip-bottom">
          <div class="tip-box">
            <i class="iconfont icon-alert"/>
            <span v-if="tabActiveStore === 'land'">填写详细地址结果更准确</span>
            <span v-else>填写邮政编码结果更准确</span>
          </div>
          <!-- <i class="iconfont icon-close" @click="isShowTipBox = false" /> -->
        </div>
        <!-- :class="{'no-shadow' : !isLandAddr }" -->
        <div class="bottom no-shadow"  @click="commitBtn">
          <button :class="['btn',(addrVal&&addressDetail)?'active':'']">确定选择</button>
        </div>
      </div>
    </mt-popup>

      <!-- 搜索详细地址 -->
      <search-popup ref="searchPopup"
                    @confirm='onSelectDetail'
                    :address="detailInfo"></search-popup>
      <!-- 省市区级联选择 寄件人 -->
      <cascade-popup :show="cityPopupVisible"
        :options="addressTreeList"
        :value="cascadeSelectValue"
        @finish="handleCascadeFinish"
        @close="cityPopupVisible = false" />
      <!-- 港澳台弹窗 -->
      <!-- :cityList.sync="sarCityData" -->
      <sar-city-popup ref="sarCityPopup"
        v-model="sarCityPopupVisible"
        :cityTreeList="sarCitiesList"
        title="所在地区"
        sortKey="headChar"
        children="childArea"
        valueKey="areaName"
        @confirm='handlerSarCity'></sar-city-popup>
      <!-- 国家弹窗 -->
      <int-country-popup v-model="countryPopupVisible"
        :selectItem="detailInfo.country"
        :hotCountries="hotCountries"
        :intCountryData="intCountryInfoList"
        @select='handlerIntCountry'></int-country-popup>
      <int-prov-popup :show="intProvVisible"
        ref="intProvDom"
        :intProvList="intProvList"
        :intCityList="intCityList"
        :intCountyList="intCountyList"
        :selectItem="detailInfo"
        @finish="clickIntProvList"
        @clickItem="getIntCityList"
        @close="intProvVisible = false" />
      <post-code-popup v-model="postCodePopupVisible"
        title="邮政编码"
        :list="selectPopupList"
        :confirmBtn="false"
        :selectItem="detailInfo.postCode"
        @input="handelSelectInput"
        @handelClick="(value)=> { detailInfo.postCode = value }"></post-code-popup>
  </div>
</template>

<script>
import CascadePopup from '../addMorePopup/cascadePopup' // 省市区
import SearchPopup from '@/components/searchPopup/index.vue' // 详细地址
import SarCityPopup from '../addMorePopup/sarCityPopup' // 港澳台省市区
import IntCountryPopup from '../addMorePopup/intCountryPopup' // 国家弹窗
import IntProvPopup from '../addMorePopup/intProvPopup' // 国际省市区弹窗
import PostCodePopup from '../addMorePopup/postCodePopup' // 邮编弹窗
import { mapState } from 'vuex'
import { Popup, Toast } from 'mint-ui'
import { setDocumentTitle } from '@/plugin/setTitle'
import sarCitiesJson from '@/libs/sarCitiesJson.json' // 港澳台地址树
import { intCountry } from '@/libs/internationalCode' // 国家地址树
import {
  getCitiesJson,
  getCountryInformation,
  getHotCountries,
  getIntProvList,
  getIntCityList,
  getLandPostCode,
  getIntPostCode
} from '@/api/index.js'

let toast = ''
export default {
  data () {
    return {
      detailInfo: {
        country: '', // 国家
        countryUnit: '', // 国家 code
        cnCountry: '', // 国家 中文
        userProvince: '',
        userCity: '',
        userArea: '',
        userProvinceCode: '',
        userCityCode: '',
        userAreaCode: '',
        value: '', // 显示的
        postCode: '', // 邮编
        location: { lng: '', lat: '' } // 高铁急送需要
      },
      addressDetail: '', // 详细地址
      intCountryInfoList: [], // 国家数据
      hotCountries: [], // 热门国家
      intProvList: [], // 州市-省
      intCityList: [], // 州市-市
      intCountyList: [], // 州市-区
      postCodeList: [], // 邮编（原）
      selectPopupList: [], // 选择数据
      cityPopupVisible: false, // 国内省市区
      sarCityPopupVisible: false, // 港澳台
      countryPopupVisible: false, // 国际国家
      intProvVisible: false, // 国际省市区
      postCodePopupVisible: false, // 邮编弹窗
      isShowTipBox: true, // 是否显示悬浮提示
      languageCode: ''
    }
  },
  components: {
    SearchPopup,
    CascadePopup,
    SarCityPopup,
    IntCountryPopup,
    IntProvPopup,
    PostCodePopup,
    'mt-popup': Popup
  },
  props: {
    show: Boolean,
    addressType: String // send receive
  },
  computed: {
    ...mapState('addressInfo', {
      sendAddressDetail: (state) => state.sendDetail.sendAddressDetail, // 寄件详细地址
      receAddressDetail: (state) => state.receDetail.receAddressDetail, // 收件详细地址
      sendInfo: (state) => state.sendDetail.sendInfo, // 寄件省市区地址
      receInfo: (state) => state.receDetail.receInfo, // 收件省市区地址
      addressTreeList: (state) => state.addressTree
    }),
    ...mapState('freightMain', {
      tabActiveStore: state => state.tabActive // land:国内 sar:港澳台 int:国际
    }),
    typeTitle () {
      if (this.tabActiveStore === 'sar' && this.addressType === 'receive') {
        return '请选择中国港澳台地址'
      }
      if (this.tabActiveStore === 'int' && this.addressType === 'receive') {
        return '请选择国际地址'
      }
      return '请选择内地地址'
    },
    addrVal () {
      let { cnCountry = '', country = '', userProvince = '', userCity = '', userArea = '', userAreaCode = '' } = this.detailInfo
      if (this.tabActiveStore === 'int' && this.addressType === 'receive') {
        return cnCountry ? `${cnCountry} ${country}` : ''
      }
      return `${userProvince}${userCity ? ' ' : ''}${userCity}${userArea && userAreaCode !== '010000F' ? ' ' + userArea : ''}`
    },
    /** 已选择的省市区联动value */
    cascadeSelectValue () {
      const { userAreaCode, userCityCode, userProvince } = this.detailInfo
      return userAreaCode || userCityCode || userProvince
    },
    isLandAddr () { // 是否是内地地址
      if (this.tabActiveStore !== 'land' && this.addressType === 'receive') {
        return false
      }
      return true
    },
    sarCitiesList () {
      return sarCitiesJson
    },
    // 国家数据 --> 已改调接口
    intCountryData () {
      return intCountry
    }
  },
  methods: {
    initHandle () {
    // 初始化标题
      // this.initTitle()
      // 初始化数据
      this.initData()
    },
    closePopup () {
      // setDocumentTitle('运费时效')
      this.$emit('closeAddressPopup')
    },
    // 确认按钮
    commitBtn () {
      if (toast) {
        toast.close()
      }
      if (!this.detailInfo.value && !this.addrVal) {
        toast = Toast({
          message: '请选择所在地区',
          position: 'middle',
          className: 'address-toast'
        })
        return false
      }
      // 内地的详细地址必填
      // if (this.isLandAddr) {
      //   if (!this.addressDetail) {
      //     toast = Toast({
      //       message: '请输入详细地址',
      //       position: 'middle',
      //       className: 'address-toast'
      //     })
      //     return false
      //   }
      // }
      // 寄件地址
      if (this.addressType === 'send') {
        this.$store.dispatch('addressInfo/setSendDetail', {
          sendInfo: this.detailInfo,
          sendAddressDetail: this.addressDetail
        })
      } else if (this.addressType === 'receive') {
        this.$store.dispatch('addressInfo/setReceDetail', {
          receInfo: this.detailInfo,
          receAddressDetail: this.addressDetail
        })
      }
      // setDocumentTitle('运费时效')
      this.$emit('addressConfirm', this.addressType)
    },

    // 初始化标题
    initTitle () {
      if (this.addressType === 'send') {
        setDocumentTitle('寄件地址填写')
      } else {
        setDocumentTitle('收件地址填写')
      }
    },
    // 初始化数据
    async initData () {
      switch (this.addressType) {
        case 'send':
          this.detailInfo = this.sendInfo
          this.addressDetail = this.sendAddressDetail
          if (!this.detailInfo.location) {
            this.detailInfo.location = { lng: '', lat: '' }
          }
          break
        case 'receive':
          this.detailInfo = this.receInfo
          this.addressDetail = this.receAddressDetail
          if (!this.detailInfo.location) {
            this.detailInfo.location = { lng: '', lat: '' }
          }
          break
        default:
          break
      }
      if (this.tabActiveStore === 'int' && this.addressType === 'receive') {
        this.getCountryInformationFunc() // 国际国家
        this.getHotCountries() // 热门国家
        this.getIntProvList() // 查国际省市区
        this.getIntPostCode() // 查邮编列表（国际）
      }
      // this.isShowTipBox = true
      this.getLandPostCode() // 查邮编列表（内地）
      if (!this.addressTreeList.length) {
        await getCitiesJson()
      }
      const list = JSON.parse(JSON.stringify(this.addressTreeList))
      this.$store.dispatch('addressInfo/setAddressTree', list) // 重新赋值一遍，保证打开省市区弹窗是最新的
    },
    /**
     * 国内 land
    */
    // 打开省市区 / 港澳台 / 国家
    async checkAddress () {
      if (this.tabActiveStore === 'sar' && this.addressType === 'receive') {
        this.sarCityPopupVisible = true
        return
      }
      if (this.tabActiveStore === 'int' && this.addressType === 'receive') {
        this.countryPopupVisible = true
        return
      }

      if (!this.addressTreeList.length) {
        await getCitiesJson()
        this.cityPopupVisible = true
        return
      }
      this.cityPopupVisible = true
      // this.$refs.selectAddress.choseAdd(this.detailInfo)
    },
    // 打开搜索地址
    searchHandle () {
      // 选择搜索地址
      this.$refs.searchPopup.onOpen()
      this.$refs.searchPopup.searchText = ''
    },
    // 搜索地址选择
    onSelectDetail (val) {
      let { addrInfo, search } = val
      Object.assign(this.detailInfo, addrInfo)
      if (addrInfo.location) {
        this.$set(this.detailInfo, 'location', {
          lng: addrInfo.location.lng || '',
          lat: addrInfo.location.lat || ''
        })
      }
      this.addressDetail = search
      // const postCode = addrInfo.userAreaCode || addrInfo.userCityCode
      // this.detailInfo.postCode = postCode
    },
    /**
     * 省市区联动选择结束 寄件人
     */
    async handleCascadeFinish (data) {
      // const _addressFormInfo = cascaderOperateFormInfo.value
      const _addressFormInfo = this.detailInfo
      const obj = ['userProvince', 'userCity', 'userArea']
      obj.forEach((key, index) => {
        // 010000F 为暂不选择
        const areaName = data.selectedOptions[index]?.areaName || ''
        const areaCode = data.selectedOptions[index]?.areaCode || ''
        _addressFormInfo[key] = areaCode === '010000F' ? '' : areaName
        _addressFormInfo[(`${key}Code`)] = areaCode === '010000F' ? '' : areaCode
      })
      // 直辖市的省和市的名字一样
      if (_addressFormInfo.userProvince === _addressFormInfo.userCity) {
        _addressFormInfo.value =
          _addressFormInfo.userCity + ' ' +
          _addressFormInfo.userArea
      } else {
        _addressFormInfo.value =
          _addressFormInfo.userProvince + ' ' +
          _addressFormInfo.userCity + ' ' +
          _addressFormInfo.userArea
      }
      // const postCode = _addressFormInfo.userAreaCode || _addressFormInfo.userCityCode
      this.detailInfo.postCode = ''
      this.addressDetail = ''
      this.getLandPostCode()

      this.cityPopupVisible = false
    },
    /**
     * 港澳台 sar
    */
    // 选择省市区
    handlerSarCity (values) {
      this.detailInfo.userProvince = values[0]?.areaName
      this.detailInfo.userCity = values[1]?.areaName || ''
      this.detailInfo.userArea = values[2]?.areaName || ''
      this.detailInfo.value =
        this.detailInfo.userProvince + ' ' +
        this.detailInfo.userCity + ' ' +
        this.detailInfo.userArea

      const SARCode = {
        香港: 'HK',
        澳门: 'MO',
        台湾: 'TW'
      }
      this.detailInfo.country = '中华人民共和国'
      this.detailInfo.countryUnit = SARCode[values[0]?.areaName] || 'CN'
    },
    /**
    * 国际 int
    */
    // 获取热门国家
    async getHotCountries () {
      if (this.hotCountries.length) {
        // 基本不会变，有就不再重复调
        return
      }
      const data = await getHotCountries()
      if (data && data.code === '000000') {
        this.hotCountries = data.info
      }
    },
    // 获取国际国家
    async getCountryInformationFunc () {
      if (this.intCountryInfoList && this.intCountryInfoList.length) {
        return
      }
      const data = await getCountryInformation()
      if (data && data.code === '000000') {
        this.intCountryInfoList = data.info
      }
    },
    // 选择国家
    handlerIntCountry (obj) {
      this.detailInfo.country = obj.countryNameEg
      this.detailInfo.countryUnit = obj.countryCode
      this.detailInfo.cnCountry = obj.countryName
      this.detailInfo.value = `${obj.countryName} ${obj.countryNameEg}`
      this.detailInfo.userProvince = ''
      this.detailInfo.userCity = ''
      this.detailInfo.userArea = ''
      this.detailInfo.postCode = ''
      this.postCodeList.length = 0
      this.getIntProvList() // 获取州市
    },
    // 国际省列表 qType:1省 2市 3区， queryText查询关键字
    async getIntProvList () {
      if (!this.detailInfo.countryUnit) {
        this.intProvList.length = 0
        return
      }
      const queryObj = {
        value: this.detailInfo.countryUnit
      }
      const data = await getIntProvList(queryObj)
      if (data && data.success) {
        this.intProvList = data.value.stateOrProvince
        this.languageCode = data.value.languageID
        this.$refs.intProvDom.tabActive = 1
      } else {
        this.intProvList.length = 0
      }
    },
    // 获取国际市
    async getIntCityList (itemP) {
      this.detailInfo.userProvince = itemP.stateOrProvinceName
      this.detailInfo.userProvinceCode = itemP.stateOrProvinceCode
      const queryObj = {
        value: {
          countryCode: this.detailInfo.countryUnit,
          provinceCode: itemP.stateOrProvinceCode,
          languageCode: this.languageCode
        }
      }
      const data = await getIntCityList(queryObj)
      if (data && data.success) {
        this.intCityList = data.value.city
        this.$refs.intProvDom.tabActive = 2
      }
    },
    // 州市最后一次点击（选中市）
    clickIntProvList (itemC) {
      this.detailInfo.userCity = itemC.cityName
      this.detailInfo.userCityCode = itemC.citySystemCode
      this.intProvVisible = false
      this.detailInfo.postCode = ''
      this.addressDetail = ''
      this.getIntPostCode() // 获取国际邮编
    },

    /**
    * other
    */
    // 获取寄件内地邮编
    async getLandPostCode () {
      this.postCodeList.length = 0
      this.selectPopupList.length = 0
      const { userProvince = '', userCity = '' } = this.detailInfo
      if (!userProvince || !userCity || !this.isLandAddr) {
        return
      }
      const queryObj = {
        value: {
          provinceName: userProvince,
          cityName: userCity
        }
      }
      const data = await getLandPostCode(queryObj)
      if (data && data.success) {
        if (this.isLandAddr) {
          // 内地的才赋值，避免点太快切到国际弹窗 接口才返回
          this.postCodeList = data.value.postCode || []
          this.selectPopupList = data.value.postCode || []
        }
      }
    },
    // 获取国际邮编(卡哈拉地区)
    async getIntPostCode () {
      this.postCodeList.length = 0
      this.selectPopupList.length = 0
      const { countryUnit = '', userProvinceCode = '', userCityCode = '' } = this.detailInfo
      if (!countryUnit || !userProvinceCode || !userCityCode) {
        return
      }
      const queryObj = {
        value: {
          languageCode: this.languageCode,
          countryCode: countryUnit,
          provinceCode: userProvinceCode,
          cityCode: userCityCode
        }
      }
      const data = await getIntPostCode(queryObj)
      if (data && data.success) {
        if (!this.isLandAddr) {
          if (!this.detailInfo.postCode) {
            this.$set(this.detailInfo, 'postCode', data.value.postCodeValue || '')
            // this.detailInfo.postCode = data.value.postCodeValue || ''
          }
          this.postCodeList = data.value.postCode || []
          this.selectPopupList = data.value.postCode || []
        }
      }
    },
    // 打开邮编弹窗
    openPostCode () {
      if (!this.postCodeList.length) {
        return
      }
      this.postCodePopupVisible = true
    },
    // 选择弹窗搜索
    handelSelectInput (val) {
      this.selectPopupList = this.postCodeList.filter((item) => item.startsWith(val))
    }
  }
}
</script>
<style lang="scss">
.address-toast {
  z-index: 3000;
}
</style>>
<style lang="scss" scoped>
@import './index.scss';
</style>
